export const ProductValues = ["Product Basic", "Product TPA", "Product Inst DC", "Product Inst DB", "Product Other"]

export const SVFFundValues = ["Cash", "Plus", "Focus", "Core", "Strategy", "Third Party", "Legacy SV", "Off"]

export const TDFFundValues = [
  "TDF Fund A",
  "TDF Fund B",
  "TDF Fund C",
  "TDF Fund D",
  "TDF Fund E",
  "TDF Fund F",
  "TDF Fund G",
  "Off",
]

